import React, { FunctionComponent } from 'react';

import './App.scss';

const AppLoading: FunctionComponent = () =>
    <div></div>

export default AppLoading;